import {Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {TranslateService} from '@ngx-translate/core';
import {SmartSelectService} from "../services/smartselect.service";
import {AlertService, IAlert} from "../tools/alert/alert.service";
import {ContactService} from "../services/contact.service";


@Component({
    selector: 'smart-form',
    templateUrl: './smartform.component.html',
    styleUrls: [
        './smartform.component.less',
        '../tools/header.less',
        '../tools/checkbox.less'],

})


export class SmartFormComponent implements OnInit {

    constructor(
        private readonly translate: TranslateService,
        public router: Router,
        public smartService: SmartSelectService,
        public contactService: ContactService,
        public alert: AlertService,
        public activatedRoute: ActivatedRoute)

    {
        this.smartModel = this.smartService.getModel();
        this.contactModel = this.contactService.getModel();
        this.reset();
    }


    @Input() show: boolean;
    @Output() onClose = new EventEmitter<boolean>();


    public error: any;
    public loading: boolean;



    ngAfterViewInit() {
    }

    ngOnInit() {
    }




    // =========== SUBMIT FORM CONTROLLER ===============

    onSubmit() {
        this.notValid = false;

        Object.keys(this.valid).forEach(p => {
            this.notValid = this.notValid || !this.valid[p]
        })
        if (this.notValid) return;

        this.setEmptyContactModelFields();
        this.contactService.setModel(this.contactModel);


        this.smartService.setModel(this.smartModel);
        // this.showModal = true;
        this.loading = true;

        this.smartService.Mail().subscribe(
            (res: any[]) => {
                // console.log('SMART Component responce ', res)

                this.loading = false;
                this.alert.setState(<IAlert>{
                    state: "show",
                    type: "success",
                    title: "Your message has been sent",
                    text: "Thank you for your feedback. We will contact with you as soon as possible."
                })

                Object.keys(this.valid).forEach(p => {
                    this.valid[p] = false;
                    // this.requestModel[p] = null;
                })


                this.resetContactModel();
                this.resetSmartModel();
                this.onClose.emit(false);

            },
            (err) => {
                this.loading = false;
                this.alert.setState(<IAlert>{
                    state: "show",
                    type: "danger",
                    title: "Server Error",
                    text: "Some thing went wrong. Please try again or contact as via mail."
                })
            }
        );


    }

    // =========== CONTACT MODEL CONTROLLER ===============

    public contactModel = <any>{};
    public valid = {
        Name: false,
        Email: false,
        Company: false,
        Country: false,
        Message: false,
        Privacy: false
    };
    public notValid = false;

    reset() {
        this.valid = {
            Name: false,
            Email: false,
            Company: false,
            Country: false,
            Message: false,
            Privacy: false
        }
        Object.keys(this.contactModel).forEach(key => {
            this.valid[key] = !!this.contactModel[key];
        })

    }

    onChangeContactModel(key, val) {
        this.notValid = false;
        this.contactModel[key] = val;
        this.valid[key] = this.isValidByKey(key, val);
        this.contactService.setModel(this.contactModel);
    }

    isValidByKey(key, val) {
        let tst = false;

        let email = /^[\w-\.\d*]+@[\w\d]+(\.\w{2,4})$/;
        let text = /[\w0-9._%+-]{3,}/;

        switch (key) {
            case 'Email':
                tst = !!val.match(email);
                break;
            case 'Name':
                tst = !!val.match(text);
                break;
            case 'Company':
                tst = !!val.match(text);
                break;
            case 'Country':
                tst = !!val.match(text);
                break;
            case 'Message':
                tst = !!val.match(text);
                break;
            default:
                tst = !!val;
        }

        return tst;
    }


    resetContactModel() {
        Object.keys(DefaultContactRequest).forEach(p => {
            this.contactModel[p] = null;
        });
        this.contactService.setModel(this.contactModel);
    }

    setEmptyContactModelFields() {
        Object.keys(DefaultContactRequest).forEach(p => {
            this.contactModel[p] = this.contactModel[p] || DefaultContactRequest[p];
        });
    }


    // =========== SMART MODEL CONTROLLER ===============

    public smartModel: any;

    onSelect(item) {
        eval('this.smartModel.' + item + '=!this.smartModel.' + item);
        this.smartService.setModel(this.smartModel);
    }

    onChangeSmartModel(key, val) {
        eval('this.smartModel.' + key + '="' + val + '"');
        this.smartService.setModel(this.smartModel);
    }

    resetSmartModel() {
        this.smartService.resetModel();
    }
    //
    // setEmptySmartModelFields() {
    //     Object.keys(DefaultSmartRequest.Market).forEach(p => {
    //         this.contactModel[p] = this.contactModel[p] || DefaultContactRequest[p];
    //     });
    // }

}

export const DefaultContactRequest = {
    Name: '--',
    Email: '--',
    Phone: '--',
    Company: '--',
    Country: '--',
    Message: '--'
};


export const DefaultSmartRequest = {
    Market: {},
    Premises: {},
    PaymentStructure: {},
    BusinessLevel: {},
    CustomText: ''
};